import type { AnalyticsSummaryMetric } from '../../types';
import styles from './ThisWeekPanel.module.css';

/** Tiles that only make sense under the "Include AI-proposed deals" lens, keyed by
 *  `AnalyticsSummaryMetric.key` (spec §3.6). The payload always carries them; the toggle only
 *  decides whether they are shown, so flipping it never refetches. */
const CANDIDATE_METRIC_KEYS = new Set(['new_proposals']);

interface Props {
  metrics: AnalyticsSummaryMetric[];
  /** OFF (the default) keeps the tile row at exactly today's shape. */
  includeCandidates?: boolean;
}

export function ThisWeekPanel({ metrics, includeCandidates = false }: Props) {
  const shown = includeCandidates
    ? metrics
    : metrics.filter((m) => !CANDIDATE_METRIC_KEYS.has(m.key ?? ''));

  return (
    <div className={styles.grid}>
      {shown.map((m) => (
        // `note` is the tile's disclosure ("incl. N since dismissed"), carried as a native title
        // tooltip — the same affordance the fund bar's segments use.
        <div key={m.label} className={styles.metric} title={m.note ?? undefined}>
          <span className={styles.label}>{m.label}</span>
          <div className={styles.valueRow}>
            <span className={styles.value} style={{ color: m.accent }}>
              {m.value}
            </span>
            {m.delta !== null && m.delta !== 0 && (
              <span
                className={`${styles.delta} ${m.delta > 0 ? styles.deltaUp : styles.deltaDown}`}
              >
                {m.delta > 0 ? '+' : ''}
                {m.delta}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
